module.exports = __webpack_public_path__ + "static/TT1446_TW-MKM01_r1-dffb1544123d4068d5277c5f804dabc4.png";